<main class="container" aria-label="paginaSobre">
  <section aria-label="expediente" id="expediente">
    <h1 class="title">Todas as Edições</h1>
    <!-- <hr class="bg-color-grey" /> -->
    <hr class="bg-color-dark-grey hr-line" />
  </section>
  <!-- <br /> -->
  <section aria-label="edicoes" id="edicoes">
    <br />
    <h2 class="negrito">Catálogo PDF</h2>
    <p class="padding">
      <a
        target="_blank"
        rel="noreferrer"
        href="{{ downloadCatalogoPdf }}"
        class="link custom-link"
        >Catálogo Nacional de Cursos Técnicos, 4ª Edição, 2020 (versão
        vigente)</a
      >
    </p>

    <h2 class="negrito">Catálogo CSV</h2>
    <p class="padding">
      <a
        target="_blank"
        rel="noreferrer"
        href="#"
        (click)="downloadCsvCatalogoCnct($event)"
        class="link custom-link"
        >Catálogo Nacional de Cursos Técnicos, 4ª Edição, 2020 (versão
        vigente)</a
      >
    </p>
    <h2 class="negrito">Atualização no Portal</h2>
    <p class="padding">
      <a
        target="_blank"
        rel="noreferrer"
        href="{{ downloadAtuslizacaoPortalPdf }}"
        class="link custom-link"
        >Registro de Alterações no Portal do CNCT</a
      >
    </p>

    <h2 class="negrito">Edições Anteriores</h2>
    <p>
      <a
        target="_blank"
        rel="noreferrer"
        href="/assets/documents/catalogos_anteriores/cnct_3a_edicao.pdf"
        class="link custom-link"
        >Catálogo Nacional de Cursos Técnicos, 3ª Edição, 2014</a
      >
    </p>
    <p>
      <a
        target="_blank"
        rel="noreferrer"
        href="/assets/documents/catalogos_anteriores/cnct_2a_edicao.pdf"
        class="link custom-link"
        >Catálogo Nacional de Cursos Técnicos, 2ª Edição, 2012</a
      >
    </p>

    <a
      target="_blank"
      rel="noreferrer"
      href="/assets/documents/catalogos_anteriores/cnct_1a_edicao.pdf"
      class="link custom-link"
      >Catálogo Nacional de Cursos Técnicos, 1ª Edição, 2008</a
    >
  </section>
</main>
